module.exports = __webpack_public_path__ + "img/7passenger_parked.2afde23e.svg";